import React, {
    useEffect,
    useMemo,
    useState,
} from "react";
import SVG from "react-inlinesvg";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@mui/material";
import { keyframes } from "@mui/system";

import { StyledSubmitButton } from "../styles";
import RewardIcon from "../../../assets/icons/Reward.svg";


const bounce = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
  100% { transform: translateY(0); }
`;
interface SubmitButtonAreaProps {
    errorMessage: string;
    pageAttentionTooltipTitle: string;
    buttonDisabled: boolean;
    onContinue: (isFromContinueBtn?: boolean) => void;
    onGoToRewards: () => void;
}

const SubmitButtonArea: React.FC<SubmitButtonAreaProps> = ({
    errorMessage,
    pageAttentionTooltipTitle,
    buttonDisabled,
    onContinue,
    onGoToRewards,
}) => {
    const { t, i18n } = useTranslation();

    const [open, setOpen] = useState(false);
    const [clicked, setClicked] = useState(false);

    const buttonStyle = useMemo(() => ({
        position: "sticky" as const,
        bottom: 20,
        marginTop: 46,
        marginLeft: 20,
        marginRight: 20,
        width: "calc(100% - 40px)",
        ...(process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BACKGROUND_COLOR
            ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BACKGROUND_COLOR }
            : {}),
        ...(process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_TEXT_COLOR
            ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_TEXT_COLOR }
            : {}),
        ...(process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BOX_SHADOW
            ? { boxShadow: process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BOX_SHADOW }
            : {})
    }), []);

    const handleClick = () => {
        setClicked(true);

        if (errorMessage) {
            onGoToRewards();
        } else {
            onContinue(true);
        }
    };

    useEffect(
        () => {
            if (clicked) {
                return;
            }

            // 5 seconds
            const timer = setTimeout(
                () => { setOpen(true); },
                5000
            );

            return () => {
                clearTimeout(timer);
            };
        },
        [clicked]
    );

    return (
        <Tooltip
            arrow
            disableHoverListener
            disableFocusListener
            disableTouchListener
            onClose={() => setOpen(false)}
            open={open}
            placement="top"
            slotProps={{
                popper: {
                    disablePortal: true,
                    slotProps: {
                        root: {
                            style: { zIndex: 0 }
                        }
                    }
                },
                tooltip: {
                    sx: {
                        fontSize: 14,
                        fontWeight: 700,
                        animation: `${bounce} 1s infinite`,
                        padding: "4px 8px",
                    }
                }
            }}
            title={pageAttentionTooltipTitle}
        >
            <StyledSubmitButton
                style={buttonStyle}
                variant="contained"
                onClick={handleClick}
                disabled={buttonDisabled}
            >
                {i18n.language !== "ja" && <SVG src={RewardIcon} />}
                {t("continue")}
            </StyledSubmitButton>
        </Tooltip>
    );
};

export default SubmitButtonArea;
